import React from 'react'
import Final from './useEffect-fetch-data';
function App() 
{
  return (
    <div className='container'>
      <Final />
    </div>
  )
}

export default App
